import requestReset from './requestReset';
import reset from './reset';

const password = {
  requestReset,
  reset,
};

export default password;
